// var swiper = new Swiper(".specjalizacjeSwiper", {
//   grabCursor: false,
//   simulateTouch: false,
//   slidesPerView: 3,
//   spaceBetween: 16,
//   loop: true,
//   navigation: {
//       nextEl: ".specjalizacjeSwiper-next",
//       prevEl: ".specjalizacjeSwiper-prev",
//     },
// });

const { Navigation, Pagination } = window;

// Rejestracja modułów globalnie dla Swiper
if (window.Swiper && window.SwiperNavigation && window.SwiperPagination) {
    window.Swiper.use([window.SwiperNavigation, window.SwiperPagination]);
}

var swiper = new Swiper(".trainers-swiper", {
//   grabCursor: false,
//   simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl: ".trainers-swiper-next",
      prevEl: ".trainers-swiper-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
});
var swiper = new Swiper(".partners-swiper", {
//   grabCursor: false,
//   simulateTouch: false,
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    navigation: {
        nextEl: ".partners-swiper-next",
        prevEl: ".partners-swiper-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
    },
});


// $(function() {
//   $('.twentytwenty-init').twentytwenty({
//     orientation: 'vertical',
//     move_with_handle_only: true,
//   });
// })
